/**
 * step-definitions-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

/**
 * The client may send a {@link StepDefinitionsRequest} when it needs to know
 * about steps it hasn't otherwise encountered yet. This may be necessary, for
 * example, after receiving a {@link SuccessorStepsResponse}, whose opaque IDs
 * might not correspond to local intake steps. The server will respond with a
 * corresponding {@link NextStepsResponse} with the requested steps. (As in its
 * "standard" usage, the response is asynchronous/non-conversational.)
 */
export class StepDefinitionsRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_STEP_DEFINITIONS;
	public static tag : MessageTag = MessageTag.REQ_STEP_DEFINITIONS;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_NEXT_STEPS);
  }

  /**
   * Construct a new {@link StepDefinitionsRequest}.
   *
   * @param ids
   *        The identifiers of the target algorithm steps.
   */
  constructor (public ids : number[])
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/graphs/step-definitions-request.ts